<!-- Header -->
<div class="header transparent-light">
  <div class="container">
    <!-- Logo -->
    <div class="header-logo">
      <h3 class="uppercase letter-spacing-1"><a routerLink="/">Maximo</a></h3>
    </div>
    <!-- Fullscreen Menu Toggle -->
    <button class="fm-toggle" (click)="toggleMenu()">
      <span class="lines"></span>
    </button>
  </div><!-- end container -->
</div>

<!-- Fullscreen Menu -->
<div class="fullscreen-menu bg-black" [ngClass]="{'fm-show': isMenuOpen}">
  <div class="fm-wrapper">
    <div class="position-middle">
      <div class="container">
        <div class="row g-4">
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div class="row g-4 align-items-center">
              <div class="col-12 col-md-6">
                <ul class="list-unstyled">
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/">Home</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/about-us">About</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/portfolio-one">Portfolio</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/blog-grid">Blog</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/contact">Contact</a></h6>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-md-6">
                <h5 class="fw-semi-bold">Contact Info:</h5>
                <ul class="list-unstyled">
                  <li>Patton Street Caulfield East VIC 3145</li>
                  <li>yoursite&#64;example.com</li>
                </ul>
                <ul class="list-inline-sm mt-4">
                  <li><a class="button-circle button-circle-sm button-circle-white-2" href="#"><i class="bi bi-facebook"></i></a></li>
                  <li><a class="button-circle button-circle-sm button-circle-white-2" href="#"><i class="bi bi-twitter-x"></i></a></li>
                  <li><a class="button-circle button-circle-sm button-circle-white-2" href="#"><i class="bi bi-instagram"></i></a></li>
                </ul>
              </div>
            </div><!-- end row(inner) -->
          </div>
        </div><!-- end row(outer) -->
      </div><!-- end container -->
    </div><!-- end position-middle -->
    <!-- Close button -->
    <button class="fm-close" (click)="closeMenu()">
      <span></span>
    </button>
  </div><!-- end fm-wrapper -->
</div><!-- end fullscreen-menu -->
<!-- end Header -->


<!-- Hero section -->
<div class="section-xl position-relative bg-dark text-center">
    <div class="container">
        <img class="img-mask-avatar-3xl" src="assets/images/about/about-me-2.jpg" alt="about-me" data-rjs="2">
        <h1 class="display-3 fw-bold"><span class="text-highlight-gradient fw-light">Hello,</span> I'm User Interface <span class="text-gradient-1 fw-light">Designer & Developer</span></h1>
    </div><!-- end container -->
    <div class="position-bottom text-center">
        <a class="button-text-1" (click)="scrollToSection('about')">scroll down</a>
    </div>
</div><!-- section-xl -->
<!-- end Hero section -->

<!-- About section -->
<div id="about" class="section-lg">
    <div class="container">
        <div class="row g-5">
            <div class="col-12 col-lg-5">
                <h6 class="font-small uppercase letter-spacing-1 mb-4">About me</h6>
                <h1 class="animate-text">The Art of Making Brands Shine.</h1>
                <a class="button-text-3 mt-3 mt-lg-4" (click)="scrollToSection('contact')">Let's Talk</a>
            </div>
            <div class="col-12 col-lg-7">
                <p>Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus.</p>
                <div class="row g-4 mt-2">
                    <!-- Progress bar 1 -->
                    <div *ngFor="let skill of skills" class="col-12 col-sm-6">
                        <div class="progress-box">
                            <h6 class="font-small uppercase fw-medium">{{ skill.name }}</h6>
                            <div class="animated-progress">
                                <div [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"><span>{{ skill.level }}</span></div>
                            </div>
                        </div>
                    </div>
                </div><!-- end row(inner) -->
                <!-- Counters -->
                <div class="row g-4 mt-3">
                    <!-- Counter -->
                    <div *ngFor="let fact of funFacts" class="col-4">
                        <h1 class="fw-semi-bold mb-0">+<span class="counter">{{fact.displayedNumber | number:'1.0-0'}}</span></h1>
                        <p>{{fact.desc}}</p>
                    </div>
                    <!-- end Counter -->
                </div><!-- end row -->
                <!-- end Counters -->
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end About section -->

<!-- Sliding Text -->
<section class="section-sm pt-0">
    <div class="sliding-text pb-3">
        <div class="container-fluid pd-0 overflow-hidden">
            <div class="row">
            <div class="col-12">
                <h2 class="display-1 fw-semi-bold mb-0 opacity-1 text-gradient-1 font-family-philosopher font-italic text-capitalize animate-left">Top Selling HTML Template. Maximo Multipurpose Template.</h2>
            </div>
            </div>
        </div>
    </div>
</section>
<!-- end Sliding Text -->

<!-- Play video section -->
<div class="section-2xl bg-image parallax" style="background-image: url(assets/images/backgrounds/video-bg-3.jpg);">
    <div class="bg-dark-05">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-8">
                    <h1 class="fw-thin display-5 line-height-150 m-0 animate-text">Designing the Future, One Idea at a Time.</h1>
                </div>
                <div class="col-12 col-md-4 text-md-end">
                    <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple mt-3 icon-xl lightbox-media-link" (click)="openPopup()"><i class="bi bi-play"></i></a>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Play video section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Portfolio section -->
<div class="section-lg">
    <div class="container">
        <div class="row portfolio-grid g-4 g-lg-5 border-radius">
            <div *ngFor="let item of portfolioItems" class="col-12 col-md-6 portfolio-item img-class" [ngClass]="item.categoryClass">
        
                <div class="portfolio-box">
                    <div class="portfolio-img">
                        <img [src]="item.image" [alt]="item.title">
                    </div>
        
                    <a routerLink="/portfolio-one"></a>
        
                    <div class="portfolio-title">
                        <div>
                            <h4>{{ item.title }}</h4>
                            <span>{{ item.category }}</span>
                        </div>
                    </div>
                </div>
        
            </div>
        </div>
    <div class="text-center mt-5">
        <a class="button-text-1" routerLink="/portfolio-two">View All Works</a>
    </div>
    </div><!-- end container -->
</div>
<!-- end Portfolio section -->

<!-- Resume section -->
<div class="section-lg bg-dark-lighter">
    <div class="container">
        <div *ngFor="let item of resumeItems; let i = index" [class.mt-5]="i !== 0">
        
            <h4 class="fw-medium mt-2 animate-text">
                {{ item.title }}
            </h4>
        
            <p>
                {{ item.description }}
            </p>
        
            <div class="d-inline-block bg-white-01 border-radius px-3 py-2 mt-4">
                <span class="d-inline-block font-small fw-semi-bold uppercase letter-spacing-1 text-white">
                    {{ item.date }}
                </span>
            </div>
        
        </div>
    </div><!-- end container -->
</div>
<!-- end Resume section -->

<!-- Clients section -->
<div class="section-lg">
    <div class="container">
        <div class="row gx-5 gy-4 align-items-center">
            <div class="col-12 col-lg-5">
                <h6 class="font-small uppercase letter-spacing-1 mb-4">My Awesome Clients</h6>
                <h1 class="fw-bold animate-text">Beyond the Box Creative Solutions.</h1>
                <a class="button-text-3 mt-3 mt-lg-4" (click)="scrollToSection('contact')">Become a Client</a>
            </div>
            <div class="col-12 col-lg-7">
                <ul class="clients-grid column-3">
                    <li *ngFor="let client of clients">
                        <a [href]="client.link">
                        <img [src]="client.img" [alt]="client.alt">
                        </a>
                    </li>
                </ul>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Clients section -->

<!-- Contact section -->
<div id="contact" class="section-sm pt-0">
    <div class="container">
        <div class="row gy-5">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
                <h1 class="fw-bold">Get In Touch</h1>
            </div>
            <!-- Contact Form -->
            <div class="contact-form">
                <form (submit)="sendEmail($event)" #contactForm="ngForm">
                    <div class="row gx-3 gy-0">
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label class="visually-hidden" for="user_name">Name</label>
                                <input class="border-radius" type="text" minlength="2" maxlength="15"
                                    [class.is-invalid]="userName.invalid && userName.touched" name="user_name" id="name"
                                    placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                    Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <input type="email" minlength="2" maxlength="35"
                                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email" class="md-input border-radius"
                                    id="email" placeholder="Email *" [(ngModel)]="formData.user_email" #userEmail="ngModel" required
                                    email>
                                <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                    A valid email is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="visually-hidden" for="message">Project Details</label>
                        <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                            class="md-textarea border-radius" id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message"
                            #userMessage="ngModel" required></textarea>
                        <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                            Project details are required.
                        </div>
                    </div>
                    <button class="button button-lg button-rounded button-font-2 button-gradient-1" type="submit" name="submit" [disabled]="contactForm.invalid" value="Send Message">Send Message</button>
                </form>
                <!-- Submit result -->
                <div class="messages mrt-20 text-center"></div>
            </div><!-- end contact-form -->
        </div><!-- end row -->
        <!-- Contact Info -->
        <div class="row g-4 g-lg-5 text-lg-center mt-5 icon-3xl">
            <div class="col-6 col-sm-6 col-lg-3">
                <i class="bi bi-telephone text-dark"></i>
                <h5 class="fw-medium mt-2 mb-0">Phone</h5>
                <p>+1 234 567 89</p>
            </div>
            <div class="col-6 col-sm-6 col-lg-3">
                <i class="bi bi-envelope text-dark"></i>
                <h5 class="fw-medium mt-2 mb-0">Email</h5>
                <p>contact&#64;yourdomain.com</p>
            </div>
            <div class="col-6 col-sm-6 col-lg-3">
                <i class="bi bi-whatsapp text-dark"></i>
                <h5 class="fw-medium mt-2 mb-0">Whatsapp</h5>
                <p>+1 234 567 89</p>
            </div>
            <div class="col-6 col-sm-6 col-lg-3">
                <i class="bi bi-geo-alt text-dark"></i>
                <h5 class="fw-medium mt-2 mb-0">Address</h5>
                <p>Ulaanbaatar, Khan-Uul, 11000</p>
            </div>
        </div><!-- end row -->
        <!-- end Contact Info -->
    </div><!-- end container -->
</div>
